import { combineReducers } from "redux";
import {
	authorization,
	profile,
	currentRoute,
	notifications,
	app,
	usersForm,
	users,
	alerts,
	alertsForm,
	currentTheme,
	consultations,
	consultationsForm,
	appointments,
	appointmentsForm,
	reviews,
	reviewsForm,
	suggestions,
	suggestionsForm,
	contacts,
	contactsForm,
  referrals,
  referralsForm,
} from "./Reducers";

export default combineReducers({
  referrals,
  referralsForm,
	contacts,
	contactsForm,
	suggestions,
	suggestionsForm,
	reviews,
	reviewsForm,
	appointments,
	appointmentsForm,
	consultations,
	consultationsForm,
	app,
	authorization,
	currentRoute,
	profile,
	notifications,
	usersForm,
	users,
	alerts,
	alertsForm,
	currentTheme,
});
